import { useState } from "react";
import axios from "axios";
import Moment from "moment";
import { useIntl } from "react-intl";
import { useUsuario } from "../../../../hooks";
import { createSnackbarAPIException, createSnackbar, AjaxBlackout } from "../../../../_common";

const LIMITE_EDICAO = 100;

export default function useEditarAtividade() {
  const [open, setOpen] = useState(false);
  const [atividadeEdicao, setAtividadeEdicao] = useState();
  const [isLoading, setIsloading] = useState(false);
  const [atividadesSelecionadas, setAtividadesSelecionadas] = useState([]);
  const { isGerente } = useUsuario();
  const intl = useIntl();

  const editarAtividade = async atividades => {
    try {
      if (atividades?.length > LIMITE_EDICAO) {
        createSnackbar(
          intl.formatMessage(
            { defaultMessage: "Selecione no máximo {limiteEdicao} atividades para editar" },
            { limiteEdicao: LIMITE_EDICAO }
          )
        );
        return;
      }

      AjaxBlackout.Show();
      setIsloading(true);
      let atividade = {};
      const primeiroId = Array.isArray(atividades) ? atividades[0].id : atividades;
      const resp = await axios.get(`/api/pipeline/atividade/buscar?id=${primeiroId}`);

      if (resp.data) {
        if (atividades.length === 1 && resp.data.atividadeConcluida) {
          createSnackbar(intl.formatMessage({ defaultMessage: "Atividade já foi concluída anteriormente!" }));
          document.dispatchEvent(new Event("atividades/lista/reload"));
          document.dispatchEvent(new Event("dashboard/atividades/reload"));
          document.dispatchEvent(new Event("detalhe-lead/timeline/reload"));
        } else {
          atividade = {
            ...resp.data,
            dia: Moment(resp.data.data).format("YYYY-MM-DD"),
            horas: Moment(resp.data.data).format("HH:mm"),
          };
          setAtividadeEdicao(atividade);
          setAtividadesSelecionadas(Array.isArray(atividades) ? atividades : []);
          if (atividade) setOpen(true);
        }
      }
    } catch (err) {
      createSnackbarAPIException(err);
    } finally {
      setIsloading(false);
      AjaxBlackout.Hide();
    }
  };

  const onClose = () => {
    setAtividadeEdicao();
    setOpen(false);
    setAtividadesSelecionadas([]);
  };

  return {
    editarAtividade,
    modalEditarAtividadeProps: { open, onClose, isGerente, atividadeEdicao, isLoading, atividadesSelecionadas },
  };
}
